"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendUrlParams = appendUrlParams;
exports.appendClientId = appendClientId;
function appendUrlParams(url, params) {
    var entries = Object.entries(params).filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null && value !== "" && !(Array.isArray(value) && value.length === 0);
    });
    if (!entries.length)
        return url;
    var _a = url.split("?"), path = _a[0], existingQuery = _a[1];
    var searchParams = new URLSearchParams(existingQuery);
    entries.forEach(function (_a) {
        var key = _a[0], value = _a[1];
        return searchParams.set(key, Array.isArray(value) ? value.join(",") : String(value));
    });
    return "".concat(path, "?").concat(searchParams.toString());
}
function appendClientId(url, clientId) {
    return appendUrlParams(url, { client_id: clientId });
}
